import { Link } from 'react-router-dom';
import styles from './CTASection.module.scss';

interface CTASectionProps {
  heading: string;
  body: string;
  ctaLabel: string;
  ctaHref: string;
}

/**
 * Single reusable end-of-page CTA band. Copy is passed in per placement so
 * it can reference the page it's on instead of reading as boilerplate.
 */
const CTASection = ({ heading, body, ctaLabel, ctaHref }: CTASectionProps) => (
  <section className={styles.ctaSection}>
    <div className={styles.container}>
      <h2>{heading}</h2>
      <p>{body}</p>
      <Link to={ctaHref} className={styles.ctaButton}>
        {ctaLabel}
      </Link>
    </div>
  </section>
);

export default CTASection;
